// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use the environment variable if available, otherwise fallback to the hardcoded URL
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://ietixdawwqppcmxtrtmq.supabase.co";

// Use the environment variable if available, otherwise fallback to the publishable key
// This fixes the issue where the Vercel production environment is missing the key
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || 
  import.meta.env.VITE_SUPABASE_ANON_KEY || 
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlldGl4ZGF3d3FwcGNteHRydG1xIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQwMzg1MTIsImV4cCI6MjA4OTYxNDUxMn0.g0lwbuahhNouFdy16SyeUFmoA5Eg33lU0J9r_tp37Gs";

// 🛡️ Safe in-memory + localStorage adapter that never throws SecurityError in restrictive WebViews (Xiaomi / Redmi / Oppo / iOS)
const safeMemoryStore = new Map<string, string>();
const safeStorage = {
  getItem: (key: string): string | null => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem(key);
      }
    } catch (e) {
      // Ignora SecurityError / DOMException silenciosamente
    }
    return safeMemoryStore.get(key) || null;
  },
  setItem: (key: string, value: string): void => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(key, value);
        return;
      }
    } catch (e) {
      // Fallback para memória se o armazenamento local estiver desabilitado ou restrito
    }
    safeMemoryStore.set(key, value);
  },
  removeItem: (key: string): void => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem(key);
      }
    } catch (e) {}
    safeMemoryStore.delete(key);
  }
};

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: safeStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});